import Link from "next/link";
import Image from "next/image";
import { CardAction } from "./mediaCard";

type CardProps = {
  image: string;
  title: string;
  description: string;
  buttonLabel: string;
  buttonLink?: string;
  priority?: boolean;
};

/**
 * Card de enlace interno: misma geometría que MediaCard (media 16/10 arriba,
 * cuerpo sólido debajo), pero navega en vez de abrir el modal externo.
 */
export default function Card({
  image,
  title,
  description,
  buttonLabel,
  buttonLink = "#",
  priority = false,
}: CardProps) {
  return (
    <Link
      href={buttonLink}
      className="group flex h-full w-full flex-col overflow-hidden rounded-2xl bg-[var(--blanco)] ring-1 ring-black/5 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--botonesSecundarios-iconoLlamativo)] focus-visible:ring-offset-2"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <Image
          src={image}
          alt={title}
          fill
          sizes="(max-width: 640px) 92vw, (max-width: 1024px) 45vw, 410px"
          priority={priority}
          className="object-cover transition-transform duration-700 ease-out group-hover:scale-105 motion-reduce:transition-none motion-reduce:group-hover:scale-100"
        />
      </div>

      <div className="flex flex-1 flex-col gap-2 p-6">
        <h3 className="text-lg md:text-xl font-bold tracking-tight text-balance text-[var(--fondoGeneral-secciones)]">
          {title}
        </h3>
        <p className="text-sm leading-relaxed text-[var(--subtitulos-descripciones-iconos)]">
          {description}
        </p>
        <div className="mt-auto">
          <CardAction label={buttonLabel} />
        </div>
      </div>
    </Link>
  );
}
